module.exports = __webpack_public_path__ + "static/media/Hero-Electric.553b489a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Hero-Electric.webp
// module id = 332
// module chunks = 0